export const SET_COMPANY_DIRECTORY = "SET_COMPANY_DIRECTORY";
export const SET_DTMF_SUPPORT_TYPE = "SET_DTMF_SUPPORT_TYPE";

export const UPDATE_CONTACTS_ACCORDION_ERROR = "UPDATE_CONTACTS_ACCORDION_ERROR";
export const UPDATE_CONTACTS = "UPDATE_CONTACTS";
export const UPDATE_OPEN_CONTACTS = "UPDATE_OPEN_CONTACTS";
export const UPDATE_CONTACT_ERRORS = "UPDATE_CONTACT_ERRORS";

export const UPDATE_CONTACTS_MODE = "UPDATE_CONTACTS_MODE";
export const UPDATE_SYNC_DOMAIN = "UPDATE_SYNC_DOMAIN";

export const setCompanyDirectory = (companyDirectory) => {
  return {
    type: SET_COMPANY_DIRECTORY,
    payload: companyDirectory,
  };
};

export const updateContacts = (contacts) => {
  return {
    type: UPDATE_CONTACTS,
    payload: contacts,
  };
};

export const updateOpenContacts = (openContacts) => {
  return {
    type: UPDATE_OPEN_CONTACTS,
    payload: openContacts,
  };
};

export const updateContactsErrors = (contactErrors) => {
  return {
    type: UPDATE_CONTACT_ERRORS,
    payload: contactErrors,
  };
};

export const updateContactsAccordionError = (contactsAccordionError) => {
  return {
    type: UPDATE_CONTACTS_ACCORDION_ERROR,
    payload: contactsAccordionError,
  };
};

export const updateContactsMode = (contactsMode) => {
  return {
    type: UPDATE_CONTACTS_MODE,
    payload: contactsMode,
  };
};

export const updateSyncDomain = (netsapiensSyncDomain) => {
  return {
    type: UPDATE_SYNC_DOMAIN,
    payload: netsapiensSyncDomain,
  };
};
